var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar-bg-image",style:(_vm.computeBgImage)},[_c('img',{attrs:{"src":_vm.src},on:{"error":_vm.avatarLoadError,"load":_vm.avatarLoaded}})])}
var staticRenderFns = []

export { render, staticRenderFns }